import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import { IconButton } from "@mui/material";
import Toolbar from '@mui/material/Toolbar';
import {useTheme} from '@mui/material/styles';

import {useOffSetTop} from 'src/hooks/use-off-set-top';
import {useResponsive} from 'src/hooks/use-responsive';

import {bgBlur} from 'src/theme/css';

import Logo from 'src/components/logo';
import SvgColor from 'src/components/svg-color';
import {useSettingsContext} from 'src/components/settings';

import {NAV, HEADER} from '../config-layout';
import {useAuthContext} from "../../auth/hooks/index";
import AccountPopover from "../common/account-popover";
import DarkModeButton from "../common/dark-mode-button";
import LanguagePopover from "../common/language-popover";
import CompanyLinkButton from "../common/company-link-button";
import NotificationsPopover from '../common/notifications-popover';

// ----------------------------------------------------------------------

export default function Header({onOpenNav}) {
  const theme = useTheme();

  const settings = useSettingsContext();

  const { user } = useAuthContext();

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = settings.themeLayout === 'mini';

  const lgUp = useResponsive('up', 'lg');

  const offset = useOffSetTop(HEADER.H_DESKTOP);

  const offsetTop = offset && !isNavHorizontal;

  const renderContent = (
    <>
      {lgUp && isNavHorizontal && <Logo sx={{mr: 2.5}} src={user?.data?.company?.logo_url} />}

      {!lgUp && (
        <IconButton variant="text" onClick={onOpenNav}>
          <SvgColor src="/assets/icons/navbar/ic_menu_item.svg"/>
        </IconButton>
      )}

      {/* <Searchbar /> */}

      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={{xs: 0.5, sm: 1}}
      >
        {(user && user.groups && (user.groups?.includes('Azienda') || user.groups?.includes('Responsabile'))) && (
          <CompanyLinkButton />
        )}

        <LanguagePopover/>

        {/* <ContactsPopover /> */}

        <DarkModeButton />

        <NotificationsPopover/>

        <AccountPopover/>
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
          height: HEADER.H_DESKTOP,
          ...(offsetTop && {
            height: HEADER.H_DESKTOP_OFFSET,
          }),
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: 'background.default',
            height: HEADER.H_DESKTOP_OFFSET,
            borderBottom: `dashed 1px ${theme.palette.divider}`,
          }),
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI + 1}px)`,
          }),
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: {lg: 5},
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  onOpenNav: PropTypes.func,
};
